module.exports = __webpack_public_path__ + "media/84_Long.cf3228cc.mp3";